import { render, staticRenderFns } from "./pop_tutor.vue?vue&type=template&id=d97252a4&scoped=true&"
import script from "./pop_tutor.vue?vue&type=script&lang=js&"
export * from "./pop_tutor.vue?vue&type=script&lang=js&"
import style0 from "./pop_tutor.vue?vue&type=style&index=0&id=d97252a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97252a4",
  null
  
)

export default component.exports